import { isBottomVisible } from '@vue-storefront/core/helpers'

/**
 * By implementing this mixin add "onBottomScroll" mthod in component.
 * It will be invoked when view reach the bottom.
 */

export default {
  mounted () {
    // CORE OVERRIDE: extend fn functionnality
    function throttled (delay, fn) {
      let lastCall = 0
      return function (...args) {
        const now = +new Date()
        if (now - lastCall < delay) {
          return
        }
        lastCall = now
        return fn(...args)
      }
    }
    const handler = () => {
      if (isBottomVisible()) {
        this.onBottomScroll()
      }
    }
    const throttledHandler = throttled(1000, handler)
    document.addEventListener('scroll', throttledHandler)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('scroll', throttledHandler)
    })
  }
}
